import React from 'react';

import {Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';

import {StyledGrid} from 'presentation/components/Grid';
import {AuthorizationsEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {LocationOptionCard} from 'presentation/components/Location/LocationOptionCard';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';

const {title, manualSelectionCard} = translations['pt-br'].privateFlow.bookingFlow.location;

export function Location() {
	const {isLaptop} = useMediaQueries();
	const navigate = useNavigate();

	const handleNavToStateSelection = () => {
		navigate(AuthorizationsEnum.REQUEST_INITIAL_FLOW_UF);
	};

	return (
		<Stack alignItems="center" mt={4} mx={isLaptop ? 2 : 'auto'}>
			<Stack width={isLaptop ? '100%' : 618} gap={2}>
				<Typography variant="subtitle2" color="text.secondary">
					{title}
				</Typography>
				<StyledGrid.Root>
					<StyledGrid.Item sm={12} md={6} lg={6}>
						<LocationOptionCard
							dataTagId={AutoSolEnum.CLICK_ESCOLHER_LOCAL_AUTOSOL}
							iconName="my-location-filled"
							label={manualSelectionCard}
							onClick={handleNavToStateSelection}
						/>
					</StyledGrid.Item>
				</StyledGrid.Root>
			</Stack>
		</Stack>
	);
}
